<template>
    <div class="pcsearch-template" ref="searchTplContainer" @scroll="loadMoreTemplates">
        <div class="custom-back">
            <iconSymbol name="pc-back" class="back-icon" :class="{ dark: isPCDarkMode == 2 }" @click.native="handleBack" />
            <span @click="handleBack">
                {{ $t("back") }}
            </span>
        </div>
        <div class="search-keyword" v-show="keyword" v-html="keywordResult"></div>
        <ClassifyItem v-if="!classify_list_empty" :select-all="selectAll" :classify_list="classify_list" @changeClassify="changeClassify" />
        <template v-if="!local_list_empty">
            <h2 class="title" :class="{ one: classify_list_empty }">{{ $t("localTemplate") }}</h2>
            <LocalItem :local_list="local_list" />
        </template>
        <!-- 绘图类型、本地模板、社区模板搜索结果为空-->
        <NotFound v-if="result_empty" :keyword="keyword" />
        <!-- 搜索出來的社区模板 -->
        <h2
            v-show="works.length > 0"
            ref="waterFallTitle"
            class="title"
            :class="{ one: classify_list_empty && local_list_empty, recommend: result_empty }"
        >
            {{ community_templates_empty ? $t("recommend") : $t("templates") }}
        </h2>
        <tplWaterfall ref="waterfall" :works="works" type="center" />
        <loading v-show="state.loading && !state.loadEnd" />
        <!-- 返回首页按钮 -->
        <div class="slider-btn" v-show="showTopBackButton" @click="backTop">
            <iconSymbol class="icon" :class="{ dark: isPCDarkMode == 2 }" name="pc-toTop" />
            <p>{{ $t("top") }}</p>
        </div>
    </div>
</template>
<script lang="ts">
    interface ClassifyTemplateInfo {
        active: boolean;
        id: number;
        classId: number;
        name: string;
        nameU: string;
        img_url: string;
        local_templates: string[];
    }
    interface LocalTemplateInfo {
        type?: string;
        name: string;
        img_url: string;
        isFree?: Boolean;
        path?: string;
    }
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import groupBy from "lodash/groupBy";
    import find from "lodash/find";
    import { PublicType } from "@/home/hooks/enum";
    import ClassifyItem from "./classify_item.vue";
    import LocalItem from "./local_item.vue";
    import NotFound from "../../NotFound.vue";
    import loading from "@/public/components/loading.vue";
    import tplCenter from "@/home/mixins/tplCenter";
    @Component({
        components: {
            ClassifyItem,
            LocalItem,
            NotFound,
            loading,
        },
    })
    export default class PCSearchTemplates extends Mixins(tplCenter) {
        showTopBackButton = false;
        selectAll = true;
        keyword = "";
        classify_list = [];
        local_list = [];
        all_local_list = [];
        classId = 0;
        state = {
            current: 1,
            size: 20,
            order: "PV",
            type: "all",
            loading: false,
            loadEnd: false,
        };
        community_templates_empty = false;
        get keywordResult() {
            return (this.$t("searchResult") as string).replace(
                "%keyword%",
                `<span class="keyword" style="font-weight: 700;">"${this.keyword}"</span>`
            );
        }
        get classify_list_empty() {
            return this.classify_list.length === 0;
        }
        get local_list_empty() {
            return this.local_list.length === 0;
        }
        get result_empty() {
            return this.classify_list_empty && this.local_list_empty && this.community_templates_empty && !this.loadingData;
        }
        backTop() {
            (this.$refs.searchTplContainer as HTMLElement).scrollTop = 0;
        }

        handleBack() {
            if (this.isPC) {
                (<any>window).$qt.jsCallBackToHomePage();
            }
        }
        changeLocalTemplate(local_templates: string[]) {
            // 获取对应的本地模板
            const list = this.all_local_list.filter((item) => local_templates.includes(item.path));
            list.unshift({
                id: -1,
                type: "create",
                name: `${this.$t("create")}${this.activeClassName}`,
                isFree: true,
            });
            this.local_list = list;
        }
        resetClassListActiveStatus(item: ClassifyTemplateInfo) {
            this.classify_list.forEach((_item) => {
                if (_item.id !== item.id && _item.active) {
                    _item.active = false;
                }
            });
        }
        tags = [];
        getClassIdByName(name: string, nameU: string) {
            const key = nameU || name;
            const list = groupBy(this.tags, (i) => i.lv1id === 0);
            const lv1s = list["false"];
            const lv2s = lv1s.reduce((prev, current) => [...prev, ...(current?.lv2 || [])], []);
            const lv3s = lv2s.reduce((prev, current) => [...prev, ...(current?.lv3 || [])], []);
            const activeLv1 = find(lv1s, (i) => i.lv1name === name);
            const activeLv2 = find(lv2s, (i) => i.lv2name === name);
            const activeLv3 = find(lv3s, (i) => i.lv3name === name);
            return activeLv1?.lv1id || activeLv2?.lv2id || activeLv3?.lv3id || PublicType.class[key];
        }
        activeClassName = "";
        async changeClassify(item: ClassifyTemplateInfo) {
            console.log("changeClassify", item);
            if ((item.active && item.id !== -1) || (this.selectAll && item.id == -1)) return;
            if (item.classId === undefined) {
                item.classId = this.getClassIdByName(item.name, item.nameU);
            }
            this.classId = item.classId;
            this.activeClassName = item.name;
            item.active = !item.active;
            this.resetClassListActiveStatus(item);
            this.selectAll = item.id == -1;
            if (item.id == -1) {
                // 选中全部
                this.local_list = this.all_local_list;
                this.community_templates_empty = false;
            } else {
                this.changeLocalTemplate(item.local_templates);
            }
            (<any>window).$qt.jsCallSearchSetCurrentIndex(item.id);
            this.clearWaterfall();
            this.getTemplates();
        }
        async getTemplates() {
            console.log("getTemplates keyword", this.keyword);
            this.state.loading = true;
            this.state.loadEnd = false;
            const params = {
                offset: (this.state.current - 1) * this.state.size,
                count: this.state.size,
                order: this.state.order,
                sort: "DESC",
                lang: "zh",
                classId: this.classId,
                price: 1,
                reduce: 1,
                type: this.state.type,
                tag: [],
            };
            // 第一次搜索和推荐社区精选模板不设置search
            if (this.classId == 0 && !this.community_templates_empty) {
                params["search"] = this.keyword;
            }
            return new Promise((resolve) => {
                this.$edApi
                    .getPublish(params)
                    .then(({ data }) => {
                        const _data = data || [];
                        this.state.loadEnd = _data.length < this.state.size;
                        this.updateWaterfall({
                            works: _data,
                            noCache: null,
                            callback: () => {
                                if (data.length < 20) {
                                    //小于20个说明已全部显示
                                    this.state.loadEnd = true;
                                }
                                this.state.loading = false;
                                resolve();
                            },
                        });
                        if (_data.length == 0) resolve();
                    })
                    .catch((err) => {
                        console.log("getTemplates err", err);
                        resolve();
                    });
            });
        }
        addTemplates() {
            try {
                this.state.current++;
                this.getTemplates();
            } catch (error) {
                console.log(error);
                this.state.loadEnd = false;
                this.state.loading = false;
            }
        }
        loadMoreTemplates(event) {
            const domScrollTop = event.target.scrollTop || 0;
            const domClientHeihgt = event.target.clientHeight || 0;
            const domScrollHeight = event.target.scrollHeight || 0;
            const waterFallTitle = <any>this.$refs.waterFallTitle;
            this.showTopBackButton = Boolean(domScrollTop > ((waterFallTitle && waterFallTitle.offsetTop) || 0));
            if (this.state.loading || this.state.loadEnd) return;
            if (domScrollTop + domClientHeihgt >= domScrollHeight) {
                this.addTemplates();
            }
        }
        async searchTemplates() {
            await this.getTemplates();
            this.community_templates_empty = this.works.length == 0;
            if (this.result_empty) {
                this.classId = 0;
                this.getTemplates();
            }
        }
        arrayBufferToBase64Png(buffer) {
            let binary = "";
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return "data:image/png;base64," + window.btoa(binary);
        }
        getImgUrl(img_url: string) {
            if (!(<any>window).$qt.jsCallGetFileData) return img_url;
            const arrayBuffer = (<any>window).$qt.jsCallGetFileData?.(img_url);
            const base64String = this.arrayBufferToBase64Png(arrayBuffer);
            return base64String;
        }
        resetData() {
            this.keyword = "";
            this.classify_list = [];
            this.local_list = [];
            this.state.current = 1;
            this.clearWaterfall();
            this.classId = 0;
            this.community_templates_empty = false;
        }
        loadingData = false;
        getData() {
            const ts = this;
            ts.loadingData = true;
            return new Promise((resolve) => {
                let request = indexedDB.open("pc_search_db", 1);
                request.onsuccess = function (event: any) {
                    let db = event.target.result;
                    let transaction = db.transaction("pc_search_tb", "readonly");
                    let objectStore = transaction.objectStore("pc_search_tb");
                    // 使用索引检索值
                    let getRequest1 = objectStore.get("search_classify_list");
                    const p1 = new Promise((resolve) => {
                        getRequest1.onsuccess = function (event: any) {
                            let data = event.target.result;
                            const list = data ? data.search_classify_list : [];
                            list.forEach((item, index) => {
                                item.img_url = ts.getImgUrl(item.img_url);
                                item.id = index;
                                item.active = false;
                            });
                            ts.classify_list = list;
                            resolve();
                        };
                        getRequest1.onerror = function () {
                            resolve();
                        };
                    });
                    const p2 = new Promise((resolve) => {
                        let getRequest2 = objectStore.get("search_local_list");
                        getRequest2.onsuccess = function (event: any) {
                            let data = event.target.result;
                            const list = data ? data.search_local_list : [];
                            list.forEach((item) => {
                                item.img_url = ts.getImgUrl(item.img_url);
                            });
                            ts.local_list = list;
                            ts.all_local_list = list;
                            resolve();
                        };
                        getRequest2.onerror = function () {
                            resolve();
                        };
                    });
                    Promise.all([p1, p2]).then(() => {
                        resolve();
                        ts.loadingData = false;
                    });
                };
                request.onerror = function () {
                    ts.loadingData = false;
                };
            });
        }
        initData(item) {
            this.$store.commit("setState", {
                type: "trackTemplateWay",
                data: "fromSearchResult",
            });
            this.selectAll = true;
            this.keyword = item ? item.keyword : sessionStorage.getItem("search_keyword");
            let search_classify_list = sessionStorage.getItem("search_classify_list");
            let search_local_list = sessionStorage.getItem("search_local_list");
            if (search_classify_list === "null" || search_local_list === "null") {
                this.getData().then(() => {
                    this.searchTemplates();
                });
            } else {
                this.loadingData = false;
                const classify_list = item ? item.classify_list : JSON.parse(search_classify_list) || [];
                classify_list.forEach((item, index) => {
                    item.img_url = this.getImgUrl(item.img_url);
                    item.id = index;
                    item.active = false;
                });
                this.classify_list = classify_list;
                const local_list = item ? item.local_list : JSON.parse(search_local_list) || [];
                local_list.forEach((item) => {
                    item.img_url = this.getImgUrl(item.img_url);
                });
                this.local_list = local_list;
                this.all_local_list = local_list;
                this.searchTemplates();
            }
        }
        inited = false;
        initSearchTemplates(item) {
            this.inited = true;
            this.initData(item);
        }
        async mounted() {
            this.$bus.$on("resetSearchData", this.resetData);
            this.$bus.$on("initSearchTemplates", this.initSearchTemplates);
            this.tags = await this.$edApi.getTagClass({
                lang: this.lang,
            });
            if (!this.inited) {
                this.resetData();
                this.initData(null);
            }
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }
        beforeDestroy() {
            this.$bus.$off("resetSearchData", this.resetData);
            this.$bus.$off("initSearchTemplates", this.initSearchTemplates);
        }
    }
</script>
<style lang="stylus" scoped>
    .pcsearch-template {
    	padding: 22px 24px 0;
    	background: var(--backgroudColor);
    	color: var(--fontSearchColor);
    	height: 100%;
    	overflow-y: scroll;

    	&::-webkit-scrollbar {
    		width: 8px;
    		height: 6px;
    		pointer-events: none;
    		background: var(--backgroudColor);
    	}

    	&::-webkit-scrollbar-thumb {
    		background: var(--scrollBackground);
    		border-radius: 4px;
    	}

    	.mo-waterfall {
    		color: var(--fontTemplateTitleColor);

    		/deep/.mo-work {
    			.mo-work--number-area {
    				span {
    					color: var(--fontTemplateDescTitleColor);
    				}

    				.mo-work--numbers {
    					.mo-ex--icon {
    						svg {
    							fill: var(--iconTemplateColor);
    						}
    					}

    					>div {
    						svg {
    							fill: var(--iconTemplateColor);
    							stroke: var(--iconTemplateColor);
    						}
    					}
    				}
    			}
    		}
    	}

    	.title {
    		font-size: 16px;
    		line-height: 20px;
    		margin-top: 8px;
    		margin-bottom: 16px;
    		font-weight: 400;

    		&.one {
    			margin-top: 0;
    		}

    		&.recommend {
    			margin-top: 0;
    		}
    	}

    	.custom-back {
    		display: flex;
    		align-items: center;
    		font-size: 16px;
    		font-weight: 700;
    		line-height: 20px;
    		cursor: default;

    		.back-icon {
    			width: 16px;
    			height: 16px;
    			margin-right: 4px;
    			stroke: #424242;

    			&.dark {
    				stroke: #DADADF;
    			}
    		}
    	}

    	.search-keyword {
    		font-size: 14px;
    		font-weight: 400;
    		line-height: 18px;
    		margin-top: 16px;
    		margin-bottom: 24px;

    		.keyword {
    			color: var(--fontTitleColor);
    		}
    	}

    	.slider-btn {
    		cursor: default;
    		width: 60px;
    		height: 66px;
    		border-radius: 8px;
    		position: fixed;
    		bottom: 32px;
    		right: 16px;
    		z-index: 1;
    		display: flex;
    		flex-direction: column;
    		justify-content: center;
    		align-items: center;
    		font-size: 11px;
    		font-weight: 400;
    		line-height: 14px;
    		color: var(--fontHomeSliderColor);
    		background: var(--backgroudHomeSliderColor);
            box-shadow: 0px 4px 16px 0px #00000014;

    		.icon {
    			margin-bottom: 4px;
    			stroke: #424242;
    			width: 24px;
    			height: 24px;

    			&.dark {
    				stroke: #dadadf;
    			}
    		}
    	}
    }
</style>
<i18n>
{
    "zh": {
        "back": "返回",
        "searchResult": "%keyword%模板的搜索结果：",
        "localTemplate": "本地模板",
        "templates": "社区模板",
        "recommend": "为您推荐的模板",
        "create": "新建",
        "top": "返回顶部"
    },
    "en": {
        "back": "back",
        "searchResult": "Search Results for %keyword% Templates:",
        "localTemplate": "Local Templates",
        "templates": "Community Templates",
        "recommend": "Recommend",
        "create": "Create ",
        "top": "Top"
    },
    "de": {
        "back": "Rückkehr",
        "searchResult": "Suchergebnisse für %keyword%",
        "localTemplate": "Lokale Vorlagen",
        "templates": "Community-Vorlagen",
        "recommend": "Persönliche Empfehlung",
        "create": "Neu ",
        "top": "Oben"
    },
    "fr": {
        "back": "retour",
        "searchResult": "Résultats de la recherche pour %keyword%",
        "localTemplate": "Modèles en local",
        "templates": "Modèles de la communauté",
        "recommend": "Recommandés pour vous",
        "create": "Nouveau ",
        "top": "Accueil"
    },
    "es": {
        "back": "regreso",
        "searchResult": "Resultados de la búsqueda de %keyword%",
        "localTemplate": "Plantillas locales",
        "templates": "Plantillas de la comunidad",
        "recommend": "Recomendaciones para ti",
        "create": "Nuevo ",
        "top": "Pantalla de Inicio"
    },
    "jp": {
        "back": "戻る",
        "searchResult": "%keyword%の検索結果",
        "localTemplate": "ローカルテンプレート",
        "templates": "コミュニティテンプレート",
        "recommend": "Recommend",
        "create": "新規作成 ",
        "top": "ホーム"
    },
    "pt": {
        "back": "Retorna",
        "searchResult": "Resultados da pesquisa para %keyword%",
        "localTemplate": "Modelos locais",
        "templates": "Modelos de comunidade",
        "recommend": "Recomendado para você",
        "create": "Criar ",
        "top": "Início"
    },
    "it": {
        "back": "ritorno",
        "searchResult": "Cerca risultati per %keyword%",
        "localTemplate": "Modelli locali",
        "templates": "Modelli della community",
        "recommend": "Consigliati per te",
        "create": "Crea ",
        "top": "Casa"
    },
    "tw": {
        "back": "返回",
        "searchResult": "%keyword% 的搜尋結果",
        "localTemplate": "本機範本",
        "templates": "社群範本",
        "recommend": "為您推薦的項目",
        "create": "新建",
        "top": "轉到主頁"
    },
    "kr": {
        "back": "돌아가기",
        "searchResult": "%keyword% 에 대한 검색 결과",
        "localTemplate": "로컬 템플릿",
        "templates": "커뮤니티 템플릿",
        "recommend": "추천",
        "create": "만들기 ",
        "top": "메인 화면 가기"
    },
    "id": {
        "back": "back",
        "searchResult": "Hasil pencarian untuk %keyword%",
        "localTemplate": "Local Templates",
        "templates": "Community Templates",
        "recommend": "Recommend",
        "create": "Create ",
        "top": "Beranda"
    },
    "ru": {
        "back": "вяртанне",
        "searchResult": "Результаты поиска для %keyword%",
        "localTemplate": "Локальные шаблоны",
        "templates": "Шаблоны сообщества",
        "recommend": "Рекомендуется вам",
        "create": "Новы ",
        "top": "Главная"
    }
}
</i18n>
